<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-md-12 col-4 mb-4">
                    <h2 >End Of Day</h2>
                    <EodTabs />
                    </div>
                    <div class="col-lg-8 col-md-12 col-8 text-right">
                        
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchCustomer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchCustomer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search by customer name" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <button  @click="openAddCustomerModal()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button> 
                        <button @click="addSchedulerModalOpen = true" type="button" class="btn btn-warning rounded"><i class="fas fa-calendar-plus"></i> ADD SCHEDULER</button>
                        
                    </div>
                </div>                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div class="row">
                            <div class="col-md-9"></div>
                            <div class="col-md-3">
                                <toggle-button v-model="isCustWithTrade" @change="onChangeEventHandler"/> Customers With Trades
                            </div>
                        </div>    
                       

                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerFirstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerFirstName'  ? 'sort-desc' : '']"  
                                    @click="sort('customerFirstName')" >Customer Name</th>
                                     
                               <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerType'  ? 'sort-desc' : '']"  
                                    @click="sort('customerType')" >Account/Type</th>
                                <th 
                                    scope="col" 
                                    class="sort "
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerEmail'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerEmail'  ? 'sort-desc' : '']"  
                                    @click="sort('customerEmail')" >Email</th>    
                                <!-- <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'spread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'spread'  ? 'sort-desc' : '']"  
                                    @click="sort('spread')" >Spread</th>         -->
                                <th 
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="customer in customers" :key="customer.id" >
                                <td>{{customer.customerFirstName ? customer.customerFirstName[0] : ""}}. {{customer.customerLastName}}</td>
                                <td>
                                    <div class="listAcc" v-for="(account,index) in customer.accountNames" :key="index" v-show="index < 2">
                                        {{account}}
                                    </div>
                                    <span  @click="openAddAccountModal(customer)" class="dropdown-item moreAcc" v-show="customer.accountNames.length > 2">
                                        ({{customer.accountNames.length - 2 }} More)
                                    </span>
                                    <span v-if="customer.accountNames.length == 0 ">N/A</span>
                                </td>
                                <!-- <td>
                                    <div class="listAcc" v-for="(account,index) in customer.customerEmails" :key="index" v-show="index < 2">
                                        {{account.email}}
                                    </div>
                                    <span  @click="openCustomerContactsModal(customer)" class="dropdown-item moreAcc" v-show="customer.customerEmails.length > 2">
                                        ({{customer.customerEmails.length - 2 }} More)
                                    </span>
                                    <span v-if="customer.customerEmails.length == 0 ">N/A</span>
                                </td> -->
                                <td>{{customer.customerEmail ? customer.customerEmail : 'N/A'}}</td>

                                <!-- <td class="coupon text-center">{{customer.spread}}</td> -->
                                <td class="text-center">
                                    <div class="d-inline-flex"> 
                                        <a  @click="openAddCustomerModal(customer)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                                        <div class="dropdown">
                                            <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-ellipsis-v"></i>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                <button @click="openAddAccountModal(customer)" class="dropdown-item" type="button">Accounts</button>
                                                <!-- <button @click="openCustomerOfferingModal(customer)"   class="dropdown-item" type="button">Offerings</button> -->
                                                <button @click="openCustomerContactsModal(customer)"   class="dropdown-item" type="button">Contacts</button>
                                                <button @click="deleteCustomer(customer)" class="dropdown-item del" type="button">Delete</button>
                                            </div>
                                        </div>
                                            <button 
                                            v-if="isCustWithTrade"
                                            :title="customer.customerEmails.length == 0 ? 'Please add contacts to sent email' : ''"
                                            :disabled="customer.customerEmails.length == 0 " 
                                            @click="toggleEmailModal(customer)" 
                                            class="btn btn-primary">SEND EMAIL</button>
                                    </div>    
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getCustomers(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <addcustomermodal 
            v-bind:customerData="customerData" 
            v-if="addCustomerModalOpen" 
            @close="closeAddcustomerModal()"/> 
        <sendemail  
            v-bind:customerData="customerData" 
            v-if="sendEmailModalOpen" 
            @close="toggleEmailModal()"
        />
        <AddSchedulerModal
            v-if="addSchedulerModalOpen"
            @close="addSchedulerModalOpen = false"
            @saved="$router.push('/reports/customers/scheduler')"
        />
        <importtradehistory
            v-if="importTradeHistoryModalOpen" 
            @close="openImportTradeHistoryModal()"/> 
        <addaccountmodal
            v-bind:customerData="customerData"
            v-bind:isMoneyLine="isMoneyLine"
            v-if="addAccountModalOpen" 
            @close="closeAccountcustomerModal()"
         />    
          <CustomerContacts 
            v-if="customerContactModalOpen" 
            v-bind:customerData="customerData"
            @close="closeCustomerContactModal()"
         />   
    </div>    
</template>
<script>

import config from "@/config";
import authService from "@/authService";
import addcustomermodal from "@/components/ims/ims-maintenance/ims-customers/ImsAddCustomerModal";
import addaccountmodal from "@/components/ims/ims-maintenance/ims-customers/ImsAddCustomerAccountModal";
import sendemail from "./reportSendEmailModal";
import importtradehistory from "./reportTradeHistoryImportModal.vue"
import CustomerContacts from "@/components/ims/ims-maintenance/ims-customers/ImsCustomerContactsModal.vue"
import EodTabs from "./EodTabs";
import AddSchedulerModal from "./reportAddSchedulerModal";

export default {
  name: "imscustomers",
  components :{
    addcustomermodal,
    sendemail,
    importtradehistory,
    addaccountmodal,
    CustomerContacts,
    EodTabs,
    AddSchedulerModal
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "customerFirstName",
        sortOrder: "ASC",
        customers : [],
        addCustomerModalOpen : false,
        sendEmailModalOpen : false,
        importTradeHistoryModalOpen : false,
        addAccountModalOpen : false,
        customerData :{},
        isMoneyLine: window.location.pathname.includes('moneyline'),
        isCustWithTrade : true,
        customerContactModalOpen : false,
        addSchedulerModalOpen : false


    };
  },
  methods: {
    onChangeEventHandler(e){
        if(e.value){
            this.getCustomersWithTrade(); 
        }else{
            this.getCustomers(); 
        }
    },
    openCustomerContactsModal(selectedCustomer){
        this.customerData =  {...selectedCustomer};
        this.customerContactModalOpen = !this.customerContactModalOpen
    },
    closeCustomerContactModal(){
        this.customerContactModalOpen = !this.customerContactModalOpen;
        this.getCustomers(this.currentPage); 
    },
    closeImportCustomerModal(){
        this.importCustomerModalOpen = false;
        this.getCustomers(); 
    },
    closeAccountcustomerModal(){
        this.addAccountModalOpen = false;
        this.getCustomers(this.currentPage); 
    },
    closeAddcustomerModal(){
        this.addCustomerModalOpen = false;
        this.getCustomers(this.currentPage); 
    },
    toggleEmailModal(selectedCustomer){
        this.customerData = selectedCustomer;
        this.sendEmailModalOpen = !this.sendEmailModalOpen;
    },
    openAddCustomerModal(selectedCustomer){
        if(selectedCustomer){
            this.customerData = {...selectedCustomer};
        }else{
            this.customerData = {};
        }
        this.addCustomerModalOpen = !this.addCustomerModalOpen
    },
    openAddAccountModal(selectedCustomer){
        this.customerData = selectedCustomer;
        this.addAccountModalOpen = !this.addAccountModalOpen
    },
     openImportTradeHistoryModal(){
        this.importTradeHistoryModalOpen = !this.importTradeHistoryModalOpen
    },
    


    deleteCustomer(customer){
        var message = "Are you sure you want to delete this customer?";

        this.$confirm(message,"Delete customer","",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            var data = { "id":customer.id,"status":"DEACTIVE"}
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .put(config.baseUrlBidSide + "/customer/status", data, auth)
            .then((result) => {
                if(result.data == "You can't delete this customer as it is part of an account"){
                    this.$alert(result.data)
                }
                this.loading = false;              
                this.getCustomers();              
            })
            .catch(() => {
                this.loading = false;              
            });
        });

    },
    searchCustomer(){
        this.getCustomers(); 
    },
    clearSearch(){
        this.searchValue = "";
        this.getCustomers(); 
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getCustomers();
    },

    getCustomers(currentPage){
        if(this.isCustWithTrade){
            this.getCustomersWithTrade(currentPage);
            return false
        }
        this.loading = true;
        if (!currentPage) {
          this.currentPage = 1;
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/customer/list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.customers = result.data.content;
          this.loading = false;
        })
    },
    getCustomersWithTrade(currentPage){
        this.loading = true;
        if (!currentPage) {
          this.currentPage = 1;
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/customer/qeod-accounts-list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.customers = result.data.content;
          this.loading = false;
        })
    }
   
  },
  mounted() {
    this.getCustomers();
  }
};
</script>